<script type="text/javascript">
const APP_SECRET = '9645c1a788e63552a6c699c28b9f77ff'
const MAC_TYPE = 'M4'
const DEVICE_TYPE = 'M5'
//  毫秒
const PING_OK = 400
const PING_GOOD = 200
export default {
  APP_SECRET,
  PING_OK,
  PING_GOOD,
  MAC_TYPE,
  DEVICE_TYPE
}
</script>



// WEBPACK FOOTER //
// Global.vue?2994b055